import type * as React from 'react';
import { createContext, useContext } from 'react';

export type ExternalLinkWarningContextType = {
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
  onAuxClick: React.MouseEventHandler<HTMLAnchorElement>;
};

const noop = () => {};

export const ExternalLinkWarningContext = createContext<ExternalLinkWarningContextType>({
  onClick: noop,
  onAuxClick: noop,
});

export const useExternalLinkWarning = () => useContext(ExternalLinkWarningContext);
